import { useState } from 'react'
import { Plus } from 'lucide-react'
import { useCurrency } from './shared'
import { t } from '../../../i18n'

// Swiss-minimal: black on white, one category at a time behind underline
// tabs, a strict three-column grid of square photos. Nothing decorative.
export default function MinimalTemplate({ menu, table, addItem, onSelectItem }) {
  const currency = useCurrency()
  const categories = menu.filter(c => c.items?.length)
  const [activeId, setActiveId] = useState(categories[0]?.id)
  const active = categories.find(c => c.id === activeId) || categories[0]

  return (
    <div className="max-w-6xl mx-auto bg-white text-black" style={{ fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif" }}>
      <header className="grid grid-cols-2 items-end border-b-2 border-black pb-4 mb-0">
        <h1 className="text-6xl md:text-8xl font-bold tracking-tighter leading-none">{t("Menu")}</h1>
        <p className="text-end text-sm">{table ? t("Table {table}", { table: table }) : ''}<br />{categories.reduce((n, c) => n + c.items.length, 0)} {t("dishes")}</p>
      </header>

      <nav className="flex gap-8 overflow-x-auto no-scrollbar border-b border-black/15 mb-10" role="tablist" aria-label={t("Menu categories")}>
        {categories.map((c, i) => (
          <button key={c.id} role="tab" aria-selected={c.id === active?.id} onClick={() => setActiveId(c.id)}
            className={`py-4 text-sm whitespace-nowrap border-b-2 -mb-px ${c.id === active?.id ? 'border-black font-bold' : 'border-transparent text-black/50 hover:text-black'}`}>
            <span className="text-black/30 me-2">{String(i + 1).padStart(2, '0')}</span>{c.name}
          </button>
        ))}
      </nav>

      {active && (
        <div role="tabpanel" className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
          {active.items.map(item => (
            <article key={item.id} className="group">
              <button onClick={() => onSelectItem(item)} className="block w-full aspect-square bg-neutral-100 overflow-hidden" aria-label={t("View {name}", { name: item.name })}>
                {item.image && <img loading="lazy" src={item.image} alt={item.name} className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 transition" onError={e => { e.currentTarget.style.display = 'none' }} />}
              </button>
              <div className="flex justify-between items-start gap-3 mt-3 border-t border-black pt-3">
                <div className="min-w-0">
                  <h3 className="font-bold leading-tight">{item.name}</h3>
                  {item.description && <p className="text-xs text-black/55 mt-1 line-clamp-2">{t(item.description)}</p>}
                </div>
                <div className="text-end shrink-0">
                  <p className="text-sm font-bold">{Number(item.price || 0).toFixed(2)}</p>
                  <p className="text-[10px] text-black/40">{currency}</p>
                </div>
              </div>
              <button onClick={() => addItem(item)} className="mt-3 w-full flex items-center justify-center gap-2 border border-black py-2 text-xs font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors">
                <Plus size={14} /> {t("Add")}
              </button>
            </article>
          ))}
        </div>
      )}
    </div>
  )
}
